module.exports = __webpack_public_path__ + "media/images/switzerland-flag-round-0263aa6e7180c654e581870cf21f9b37.png";